module.exports = __webpack_public_path__ + "static/media/services_manicure2.2a3dc791.jpg";